import Arena from './Arena';
import ChooseSeats from './ChooseSeats';
import ChooseSection from './ChooseSection';
import SeatsList from './SeatsList';
import DataStorage from './dataStorage';
import C from './Constants';

export default class Seating {
    constructor() {

        if (!$('.seat-suggestion').length || $(".seatfirst-arena").length) {
            return false;
        }

        this.currentSection = null;
        this.initialSectionCode = $('.seat-suggestion').attr('data-selected-section') && $('.seat-suggestion').attr('data-selected-section').length ? $('.seat-suggestion').attr('data-selected-section') : null;

        this.eventId = parseInt(document.querySelector('.seat-suggestion').dataset.eventId);
        this.isSeason = document.querySelector('.seat-suggestion').dataset.isSeason.toLowerCase() == 'true';

        this._onChooseOwnSeats = this._onChooseOwnSeats.bind(this);
        this._onBackToChooseSection = this._onBackToChooseSection.bind(this);

        // Arena callbacks
        this._onArenaDataLoaded = this._onArenaDataLoaded.bind(this);
        this._onSelectInitialSection = this._onSelectInitialSection.bind(this);

        // SeatList callbacks
        this._onSeatsList_onSeatClick = this._onSeatsList_onSeatClick.bind(this);
        this._onSeatsList_onStateChange = this._onSeatsList_onStateChange.bind(this);

        // ChooseSection callbacks
        this._onChooseSectionClickArea = this._onChooseSectionClickArea.bind(this);
        this._onGetSectionByCode = this._onGetSectionByCode.bind(this);
        this._onChooseSectionSetVisibiltyOnToggleUngroup = this._onChooseSectionSetVisibiltyOnToggleUngroup.bind(this);

        // ChooseSeats callbacks
        this._onChooseSeats_onSeatClick = this._onChooseSeats_onSeatClick.bind(this);

        this._isEvent = this._isEvent.bind(this);

        // Resize handler for all instances
        this._onResize = this._onResize.bind(this);
        window.addEventListener('resize', this._onResize);


        this._init();

        window.history.pushState = new Proxy(window.history.pushState, {
            apply: (target, thisArg, argArray) => {
                // trigger here what you need              
                return target.apply(thisArg, argArray);
            },
        });

        let _this = this;
        $(window).on("popstate", function () {
            // For Back in webbrowser
            _this._onBackToChooseSection();
        });

    }

    /**
     * INIT
     */

    _init() {

        //setup Common DataStorage
        this.dataStorage = new DataStorage(this.eventId, this.isSeason);

        this.seatsList = new SeatsList({
            onSeatClick: this._onSeatsList_onSeatClick,
            onStateChange: this._onSeatsList_onStateChange,
            dataStorage: this.dataStorage
        });


        // setup Arena
        this.arena = new Arena({
            onArenaDataLoaded: this._onArenaDataLoaded,
            onSelectInitialSection: this._onSelectInitialSection,
            initialSectionCode: this.initialSectionCode,
            dataStorage: this.dataStorage
        });


        // setup ChooseSection
        this.chooseSection = new ChooseSection({
            onStateChange: this._onSeatsList_onStateChange,
            onChooseSectionClickArea: this._onChooseSectionClickArea,
            onGetSectionByCode: this._onGetSectionByCode,
            onToogleVisibilityChange: this._onChooseSectionSetVisibiltyOnToggleUngroup,
            dataStorage: this.dataStorage
        });

        // setup ChooseSeats
        this.chooseSeats = new ChooseSeats({
            onSeatClick: this._onChooseSeats_onSeatClick,
            dataStorage: this.dataStorage
        });


        let _this = this;
        this.dataStorage.init().done(function () {
            // init components when common data is loaded
            if ($("#activate-ungroup-setting").val() == "true") {
                _this._onSeatsList_onStateChange(C.STATE_SEATS_UNGROUPED);
                this.ungroupedIndex = 0;
                $('#choose-section-header input[type=checkbox]').prop('checked', true);
                $('#choose-seats-header input[type=checkbox]').prop('checked', true);

            } else {
                $('#choose-section-header input[type=checkbox]').prop('checked', false);
                $('#choose-seats-header input[type=checkbox]').prop('checked', false);
                $('.changeable').removeClass('changeable').removeClass('next-selection');
            }

            _this.seatsList.reloadCart();
            _this.arena.loadArenaData();
        });

        $('.choose_own_seats').on('click', this._onChooseOwnSeats); // setup choose own seats button
        $('.back_to_choose_section').on('click', this._onBackToChooseSection); // back to overviewn 
    }




    /* ChooseSeats Component
     ----------------------------- */
    _onChooseSeats_onSeatClick(seat) {
        this.dataStorage.SetConfirmedSeat(seat);
        this.seatsList.reloadCart();
        this.chooseSeats.bind();

        // Trigger cartUpdate for reservationstimer and CartIndicator
        const startEvent = new Event("cartUpdateEvent");
        document.dispatchEvent(startEvent);

        this._setVisibilityOnFindTicketsButton();
    }



    /* SeatsList Component
     ----------------------------- */
    _onSeatsList_onSeatClick(index) {
        this.dataStorage.selectedSeat = this.dataStorage.cart[index];
        this._onChooseOwnSeats();
        return;
    }

    _onSeatsList_onStateChange(state) {
        this.dataStorage.state = state;
        this.chooseSeats.state = state;
        this.chooseSection.state = state;

        this.chooseSection.bind();
        this.chooseSeats.bind();
        this.seatsList.bind();
    }



    /* ChooseSection Component
       ----------------------------- */
    _onGetSectionByCode(code) {
        return this.arena.getSectionByCode(code);
    }
    _isEvent(cartitem) {
        return cartitem.eventId == this.eventId;
    }
    _setVisibilityOnFindTicketsButton() {
        $(".btn-find-tickets").show();
        // filter on eventid
        if (this.dataStorage.cart.length > 0) {
            var index = this.dataStorage.cart.filter(this._isEvent).map(function (e) { return e.unSeated; }).indexOf(true);
            if (index >= 0) {
                $(".btn-find-tickets").hide();
            }
        }
    }

    _onChooseSectionClickArea(code) {
        this._setVisibilityOnFindTicketsButton();

        let section = this.arena.getSectionByCode(code);
        if (!section) {
            return false;
        }

        $('#choose-section-header').addClass('d-none');
        $('#choose-seats-header').removeClass('d-none');

        this.currentSection = section;
        this.seatsList.open(section);
        this.chooseSeats.loadSection(section, this.arena.getPOI());

        $('.choose-section').hide();
        $('.choose-own-seats').show();

        var href = "" + window.location;
        var idx = href.indexOf("&section=");
        if (idx > 0) { href = href.substring(0, idx); }
        href = href + "&section=" + code;
        window.history.pushState({ href: href }, '', href);
    }

    _onChooseSectionSetVisibiltyOnToggleUngroup(flag) {
        this.dataStorage.showToggleUngroupCheckbox = flag;
        if (!flag) {
            let state = C.STATE_SEATS_UNGROUPED;
            this.dataStorage.state = state;
            this.chooseSeats.state = state;
            this.chooseSection.state = state;
        }
        this.seatsList.reloadCart();
    }




    /* Arena Component
       ----------------------------- */

    _onArenaDataLoaded() {
        this._onResize();
        $('.unhappy').addClass('enable');

        if (!useAutoSeating) { // from mvc-view
            this._onChooseOwnSeats();
        }
    }

    _onSelectInitialSection(sectionData) {
        this.currentSection = sectionData;
    }







    /* EVENT HANDLERS FOR INDEX 
     ----------------------------- */
    _onChooseOwnSeats() {
        if (!this.arena.loaded()) {
            return false;
        }

        // hide suggestion parts
        $('.seating-tabs').hide();
        $('.seat-suggestion').hide();

        $('.choose-section').show();
        $('#razor-seats-selection').hide();
        $('#choose-section-header').removeClass('d-none');
        $('#choose-seats-header').addClass('d-none');

        $('.seats-list').show();
        this.chooseSection.open();

        var href = "" + window.location;
        window.history.pushState({ href: href }, '', href);

        return false;
    }

    _onBackToChooseSection() {

        $('.seating-tabs').hide();
        this.chooseSeats._hideLoader();
        this.chooseSeats._clearError();

        $('.choose-own-seats').hide();
        $('.choose-section').show();

        $('#choose-section-header').removeClass('d-none'); 
        $('#choose-seats-header').addClass('d-none');

        this.chooseSection.open();
        this.chooseSection.resetViewport();

        this.chooseSeats.bind();

        this.dataStorage.clearSectionData();
        this.seatsList.section = null;
        this.seatsList.sectionData = null;
        this.seatsList.reloadCart();

        var href = "" + window.location;
        var idx = href.indexOf("&section");
        if (idx > 0) { href = href.substring(0, idx); }
        window.history.pushState({ href: href }, '', href);

        return false;
    }




    _onResize() {

        if (this.arena) {
            this.arena.onResize();
        }

        if (this.chooseSection) {
            this.chooseSection.onResize();
        }

        if (this.chooseSeats) {
            this.chooseSeats.onResize();
        }
    }


}